module.exports = __webpack_public_path__ + "img/horizontal_5_1_5010.0d811779.png";